<template>
  <div class="WList el-input el-input--small">
    <el-input v-model="formData[item.id]" readonly>
      <el-button
        v-if="!disabled"
        size="medium"
        type="text"
        slot="suffix"
        @click="listViewShow"
      >
        <svg-icon icon-class="list"></svg-icon>
      </el-button>
    </el-input>
  </div>
</template>

<script>
export default {
  name: 'WList',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    // 传入控件
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    // 表单对象
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    listViewShow() {
      this.$emit('listViewShow')
    }
  }
}
</script>

<style lang="scss">
.WList {
  .el-button {
    padding: 0 !important;
  }
  /* height: 28px; */
  /* margin-top: 6px; */
}
</style>